import { Component, Input } from '@angular/core';
import { paginationParams } from './pagination.abstract';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})
export class PaginationComponent extends paginationParams {
}
